module.exports = __webpack_public_path__ + "static/media/Guitar-4.6e8bd4d6.jpg";